module.exports = __webpack_public_path__ + "img/user-placeholder.02fcbc0f.png";